import {EnrollTrackRole} from 'Users/models/User/EnrollmentTrackingUserType';

export class EnrollmentTechnologyPartnerUserType {
  public readonly key = 'EnrollmentTechnologyPartnerUserType';
  public readonly enrollTrackRole = EnrollTrackRole.EnrollmentTechnologyPartner;
}
